import { useState } from "react";
import { useNavigate } from "react-router";
import Markdown from "react-markdown";
import StartDialog from "../components/start_dialog";
import introPhoto from "../assets/images/intro-photo.png";
import introBackPhoto from "../assets/images/intro-background.png";
import t from "../locales";

export default function Intro({ onStart }) {
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  function handleSubmit({ groupCode, groupName }) {
    if (!groupCode || !groupName) return;

    setIsDialogOpen(false);
    onStart({ groupCode, groupName });
    navigate("/personages");
  }

  return (
    <>
      <title>{t("intro.page-title")}</title>
      <img className="page__background" src={introBackPhoto} alt="" />
      <article className="card card--intro">
        <div className="card__photos">
          <div className="card__photo card__photo--back">
            <img className="card__image" src={introBackPhoto} alt="" />
          </div>
          <div className="card__photo card__photo--front">
            <img
              className="card__image"
              src={introPhoto}
              alt={t("intro.photo-alt")}
            />
          </div>
        </div>
        <div className="card__body">
          <div className="card__header">
            <h1 className="card__title">{t("intro.title")}</h1>
            <div className="card__description markdown">
              <Markdown>{t("intro.description")}</Markdown>
            </div>
          </div>
          <button
            className="button"
            type="button"
            onClick={() => setIsDialogOpen(true)}
          >
            {t("intro.next")}
            <svg
              className="button__icon"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M7.825 13H20V11H7.825L13.425 5.4L12 4L4 12L12 20L13.425 18.6L7.825 13Z" />
            </svg>
          </button>
        </div>
      </article>
      <StartDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSubmit={handleSubmit}
      />
    </>
  );
}
